import { defineComponent } from 'vue'
import styles from './styles.module.scss'

/**
 * 戳点渲染功能模块
 */
export default defineComponent({
  name: 'position-icon-view',
  emits: ['handleLocation'],

  setup: (props, { emit }) => {
    const handleLocation = () => {
      emit('handleLocation')
    }
    return () => (
      <div class={['icon', 'square', 'location', styles.location]} onClick={handleLocation}>
        <ns-icon
          name={(process.config as any).icon.location_outline}
          size={window.client === 'mobile' ? '20px' : '24px'}
        />
      </div>
    )
  },
})
